import YSF from '@neysf/qiyu-web-sdk';
import imUserInfoformat from "@/utils/imUserInfoformat";

const channelId = "59a71648a042e00da1e588d8d2986359";

export default {
  namespaced: true,
  state: {
    isYSFLoaded: false,        // SDK 是否加载完成
    isLoggedIn: false,         // 用户是否已登录
    unreadMessages: 0,         // 未读消息数
    conversationList: [],      // 会话列表
    isReconnecting: false,     // 是否正在重连
    ysfInstance: null,         // SDK 返回的 ysf 实例
    lastReconnectTime: 0,       // 上次重连时间（防抖用）
    url:'',
    imFull:false
  },

  mutations: {
    setYSFLoaded(state, value) {
      state.isYSFLoaded = value;
    },
    setLoggedIn(state, value) {
      state.isLoggedIn = value;
    },
    setUnreadMessages(state, value) {
      state.unreadMessages = value;
    },
    setConversationList(state, value) {
      state.conversationList = value;
    },
    setReconnecting(state, value) {
      state.isReconnecting = value;
    },
    setYSFInstance(state, instance) {
      state.ysfInstance = instance;
    },
    setLastReconnectTime(state, timestamp) {
      state.lastReconnectTime = timestamp;
    },
    setUrl(state,value){
      state.url = value
    },
    setImFull(state,value){
      state.imFull = value
    }
  },

  actions: {
    // 初始化客服 SDK
    initCustomerService({ commit, dispatch }) {
      YSF.init(channelId, { hidden: 1 })
        .then(ysf => {
          commit('setYSFLoaded', true);
          commit('setYSFInstance', ysf);

          // SDK 准备就绪
          ysf('onready', () => {
            console.log('SDK已加载并准备就绪');
            dispatch('configureUser');
            commit('setReconnecting', false);
           
          });
          // 重连成功
          ysf('onreconnect', () => {
            console.log('重连成功');
            commit('setReconnecting', false);
          });

          // 掉线处理
          ysf('ondisconnect', () => {
            console.log('掉线了，正在尝试重连...');
            commit('setReconnecting', true);
            dispatch('reconnect');
          });
        })
        .catch(error => {
          console.error('SDK加载失败---', error);
          commit('setYSFLoaded', false);
        });
    },

    // 重连机制（防抖处理）
    reconnect({ state, dispatch, commit }) {
      const now = Date.now();
      const cooldown = 5000; // 5 秒节流时间

      if (!state.isReconnecting || (now - state.lastReconnectTime < cooldown)) {
        console.log('重连请求被节流');
        return;
      }

      commit('setLastReconnectTime', now);

      YSF.init(channelId, { hidden: 1 })
        .then(ysf => {
          console.log('重新连接成功');
          dispatch('initCustomerService'); // 重新绑定事件
        })
        .catch(error => {
          console.log('重连失败', error);
        });
    },

    // 配置用户信息
    configureUser({ state, rootState,commit }) {
      const { ysfInstance, isYSFLoaded } = state;
      
      if (isYSFLoaded && ysfInstance) {
        commit('setUrl',ysfInstance('url'))
        const userInfo = imUserInfoformat(rootState.user.user); // 从 user 模块取用户信息
        ysfInstance('config', userInfo);
      } else {
        console.log('SDK未加载或实例不存在');
      }
    },

    // 获取未读消息数
    getUnreadMessages({ state, commit }) {
      if (state.isYSFLoaded && state.ysfInstance) {
        state.ysfInstance('getUnreadMsg', unread => {
          commit('setUnreadMessages', unread);
        });
      } else {
        console.log('SDK未加载或实例不存在');
      }
    },

    // 获取会话列表
    getConversationList({ state, commit }) {
      if (state.isYSFLoaded && state.ysfInstance) {
        state.ysfInstance('getConversation', list => {
          commit('setConversationList', list);
        });
      } else {
        console.log('SDK未加载或实例不存在');
      }
    },
    setImFull({commit},value){
      commit('setImFull',value)
    }
  },

  getters: {
    isYSFLoaded: state => state.isYSFLoaded,
    isLoggedIn: state => state.isLoggedIn,
    unreadMessages: state => state.unreadMessages,
    conversationList: state => state.conversationList,
    isReconnecting: state => state.isReconnecting
  }
};
